



import {Component, Vue, Watch} from 'vue-property-decorator';
import { debounce } from 'lodash';
/*SG

  #### global events:
  - error-message
  - success-message
  - warning-message
  - bug-message

*/
@Component
export default class Content extends Vue {
  mounted() { 
    const { bus } = this as any;

    const showMessageDebounced = debounce((messages: any[], options: any)=>{
      let message = messages.join('<br>');
      messages.length = 0; //clear messages

      this.$toasted.show(message, {
        position: 'bottom-right',
        duration: 5000,
        ...options
      });

    },350) as Function;

    let collectedMessages: any = {};

    const showMessage = (theme: string, message: string, options:any) => {
      collectedMessages[theme] = Array.from(new Set([
        ...collectedMessages[theme] || [],
        message
      ]));

      if (collectedMessages[theme].length)
        showMessageDebounced(collectedMessages[theme], {
          theme: theme,
          ...options
        });
    };

    bus.on('toast-error', (message: any, options: any)=>{
      showMessage('bubble', message, {
        ...options,
        ...(options?.dontHide && {
          className : 'dontHide',
          duration:600000, // 10 min
          action:{
            text : '',
            class : 'toasted__close far fa-times v-icon',
            onClick : (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        })
      });
    });

    bus.on('toast-success', (message: any, options: any)=>{
      showMessage('success', message, {
        ...options,
        duration:2000,
      });
    });

    bus.on('toast-warning', (message: any, options: any)=>{
      showMessage('warning', message, {
        ...options,
        ...(options?.dontHide && {
          className : 'dontHide',
          duration:600000, // 10 min
          action:{
            text : '',
            class : 'toasted__close far fa-times v-icon',
            onClick : (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        })
      });
    });

    bus.on('toast-clear', ()=>{
      this.$toasted.clear();
    });
  }

}
